import React from 'react';
import { Card, CardBody, CardHeader } from '../../components/ui';
import { useAuth } from '../../auth/AuthProvider';
import { ADMIN_GROUP_NAME, isCommitteeAdmin } from '../../lib/admin';

export default function AdminAccessGate(props: { children: React.ReactNode }) {
  const { loading, user } = useAuth();

  if (loading && !user) {
    return (
      <Card>
        <CardHeader title="Admin" subtitle="Restricted area" />
        <CardBody className="space-y-2">
          <div className="text-sm font-semibold text-zinc-900">Checking access</div>
          <div className="text-sm text-zinc-600">Confirming your Wild Apricot group membership.</div>
        </CardBody>
      </Card>
    );
  }

  if (!isCommitteeAdmin(user)) {
    return (
      <Card>
        <CardHeader title="Admin" subtitle="Restricted area" />
        <CardBody className="space-y-2">
          <div className="text-sm font-semibold text-zinc-900">Access denied</div>
          <div className="text-sm text-zinc-600">
            Admin access is limited to members of the {ADMIN_GROUP_NAME} Wild Apricot group.
          </div>
        </CardBody>
      </Card>
    );
  }

  return <>{props.children}</>;
}
